import Model from './model';

export default class LogicBaseCollectionSubscription extends Model {
  constructor(_id, follower, collection, emailShared, disableNotifications, seenApps) {
    super();
    this._id = _id;
    this.follower = follower;
    this.collection = collection;
    this.emailShared = emailShared;
    this.disableNotifications = disableNotifications;
    this.seenApps = seenApps;
  }
  getJson = () => {
    const { _id, follower, collection, emailShared, disableNotifications, seenApps } = this;
    return {
      _id,
      fr: follower,
      c: collection,
      es: emailShared,
      dn: disableNotifications,
      sa: seenApps,
    }
  }
}
